import { throttle } from 'throttle-debounce';
import $ from '../lib/jquery';

import { Component } from '../core/component';

export class OnScroll extends Component {
    selector = '.js-on-scroll';

    init() {
        $(window).on('scroll', this.onScroll);
    }

    onScroll = throttle(75, () => {
        const scroll = window.scrollY || window.pageYOffset;

        this.$elements.each((index, element) => {
            const $element = $(element);
            const offset = $element.data('offset');

            if (scroll >= offset) {
                OnScroll.scrolledDown($element);
                return;
            }

            OnScroll.scrolledUp($element);
        });
    });

    static scrolledUp($element) {
        if (!$element.data('scrolled')) {
            return;
        }

        $element.removeClass('is-scrolled');

        $element.data('scrolled', false);
    }

    static scrolledDown($element) {
        if ($element.data('scrolled')) {
            return;
        }

        $element.addClass('is-scrolled');

        $element.data('scrolled', true);
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/OnScroll.js